import { progressEpic } from "epics/base-epic";
import { WORKING_ORDER } from "constants/action-types";
import { add as snackbarAdd } from "actions/snackbars";
import { format } from "lib/globalize-util";
import type { IWorkingOrderDraftPayload } from "types/working-order/draft";
import siteConfig from "site-config";
import app from "lib/app";
import type { IOrder } from "records/order";

export const sendDraftEpic = progressEpic<IWorkingOrderDraftPayload, IOrder>(
    WORKING_ORDER.DRAFTS.SAVE,
    ({ payload }) => ({
        method: payload.draftWrapper.draft.original_order_id ? "POST" : "PUT",
        url:
            siteConfig.api +
            (payload.draftWrapper.draft.original_order_id
                ? "/draft/" + payload.draftWrapper.draft.original_order_id
                : "/draft"),
        body: payload.draftWrapper,
    }),
    {
        finishActions: (response, action) => {
            if (response) {
                app.legacy.sendMessage({
                    action: "save-draft",
                    draft: response,
                });
            }
            return [];
        },
        errorActions: () => [snackbarAdd({ message: format("Error while saving draft") })],
    },
);
